class ShowMoreService {
    constructor(
        selector = '[data-widget="cat-content"]',
        filterButtonSelector = "[data-filter-toggle]",
        extraFilterSelector = ".js-extra-filter"
    ) {
        this.selector = selector;
        this.filterButtonSelector = filterButtonSelector;
        this.extraFilterSelector = extraFilterSelector;

        document.addEventListener("DOMContentLoaded", () => {
            this.initTextBoxes();
            this.initFilterToggle();
        });
    }

    // --- BISHERIGE LOGIK (unverändert, nur in eigene Methode gepackt) ---
    initTextBoxes() {
        document.querySelectorAll(this.selector).forEach((el) => {
            const box = el.querySelector(".js-textbox");
            const toggle = el.querySelector(".js-toggle");
            const fade = el.querySelector(".js-fade");
            if (!box) return;

            toggle?.classList.add("hidden");
            fade?.classList.add("hidden");

            const maxH = parseFloat(getComputedStyle(box).maxHeight);
            const isShort = box.scrollHeight <= maxH + 1;

            if (!isShort) {
                toggle?.classList.remove("hidden");
                toggle?.classList.add("flex");
                fade?.classList.remove("hidden");
            }
        });
    }

    // --- NEU: TOGGLE FÜR WEITERE FILTER ---
    initFilterToggle() {
        document.querySelectorAll(this.filterButtonSelector).forEach((button) => {
            button.addEventListener("click", () => this.toggleFilters(button));
        });
    }

    toggleFilters(button) {
        const form = button.closest("form");
        if (!form) return;

        const extras = form.querySelectorAll(this.extraFilterSelector);
        if (!extras.length) return;

        const isOpen = button.dataset.state === "open";

        // Extra-Filter wirklich ein-/ausblenden
        extras.forEach((el) => {
            if (isOpen) {
                el.classList.add("hidden");
            } else {
                el.classList.remove("hidden");
            }
        });

        const labelMore = button.getAttribute("data-label-more") || "Weitere Filter";
        const labelLess = button.getAttribute("data-label-less") || "Weniger Filter";

        const labelSpan = button.querySelector("[data-filter-toggle-label]");
        if (labelSpan) {
            labelSpan.textContent = isOpen ? labelMore : labelLess;
        }

        const iconPlus = button.querySelector(".js-icon-plus");
        const iconMinus = button.querySelector(".js-icon-minus");

        if (iconPlus && iconMinus) {
            if (isOpen) {
                iconPlus.classList.remove("hidden");
                iconMinus.classList.add("hidden");
            } else {
                iconPlus.classList.add("hidden");
                iconMinus.classList.remove("hidden");
            }
        }

        button.dataset.state = isOpen ? "closed" : "open";
    }
}

export default ShowMoreService;
